import React from 'react';
import { Typography } from '@mui/material';
import { DotLoader } from './DotLoader';

export const LoadingText = ({ text }: { text: string }) => (
  <Typography
    variant="h5"
    role="status"
    aria-label={text}
    sx={{ fontWeight: 400, color: 'rgba(0,0,0,0.45)' }}
  >
    {text}
    <DotLoader initialDots={0} />
  </Typography>
);
